import { makeStyles } from 'lib/components';

// #genai - styles match ServiceAgreementStyles for visual consistency
export default makeStyles(() => ({
  achAuthorizationPaper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    margin: '0px',
    padding: '24px',
    width: '100%',
    borderRadius: '0px',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
      margin: '16px 24px 16px 24px',
      width: 'auto',
    },
  },
  detailsContainer: {
    display: 'flex',
    gap: '24px',
  },
}));
